// Data files
import ACT from "utils/data/act_subjects.json";
import NSW from "utils/data/nsw_subjects.json";
import QLD from "utils/data/qld_subjects.json";
import SA_NT from "utils/data/sa_nt_subjects.json";
import TAS from "utils/data/tas_subjects.json";
import VIC from "utils/data/vic_subjects.json";
import WA from "utils/data/wa_subjects.json";
import { sortSubjects } from "utils/generalHelpers";

// export const getCourses = australianState => {
//   let url = `course-compass/app/data/${australianState.toLowerCase()}_subjects.json`;
//   return api.get(url).then(response => {
//     return response.data.sort((a, b) =>
//       a.subject_desc < b.subject_desc ? -1 : 1
//     );
//   });
// };

// Cant do dynamic imports ):
// export const getCourses = australianState => {
//   return import(
//     `utils/data/${australianState.toLowerCase()}_subjects.json`
//   ).then(module => {
//     return module.default.sort((a, b) =>
//       a.subject_desc < b.subject_desc ? -1 : 1
//     );
//   });
// };

// export const importCourses = url => {
//   return import(url).then(module => {
//     return module.default.sort((a, b) =>
//       a.subject_desc < b.subject_desc ? -1 : 1
//     );
//   });
// };

export const importAllCourses = () => {
  const sortedSANT = sortSubjects(SA_NT);
  const ALL_COURSES_BY_STATE = {
    ACT: sortSubjects(ACT),
    NSW: sortSubjects(NSW),
    QLD: sortSubjects(QLD),
    SA: sortedSANT,
    NT: sortedSANT,
    TAS: sortSubjects(TAS),
    VIC: sortSubjects(VIC),
    WA: sortSubjects(WA)
  };
  return ALL_COURSES_BY_STATE;
};
